import { MutationTree } from 'vuex';

import { INIT_NOTIFICATION_MUTATION, HIDE_NOTIFICATION_MUTATION } from './mutationTypes';

import { NotificationState } from './types';

export const mutations: MutationTree<NotificationState> = {
  [INIT_NOTIFICATION_MUTATION](state, payload: Partial<NotificationState>) {
    const { message = '', mode = '', dialogMessage = '' } = payload;
    state.message = message;
    state.mode = mode;
    state.dialogMessage = dialogMessage;
  },
  [HIDE_NOTIFICATION_MUTATION](state) {
    state.message = '';
    state.mode = '';
    state.dialogMessage = '';
  },
};
